import { Injectable } from '@angular/core';
import { SettingsService } from '@delon/theme';
import { environment } from '../../../environments/environment';

/**
 * Service to determine feature visibility state (dev, prod, internal).
 * Use in templates with *ngIf, e.g. *ngIf="featureState.isInternal()".
 */
@Injectable({ providedIn: 'root' })
export class FeatureStateService {
  constructor(private settings: SettingsService) {}

  /** Visible only in local development (!environment.production). */
  isDev(): boolean {
    return !environment.production;
  }

  /** Visible only in production. */
  isProd(): boolean {
    return environment.production;
  }

  /** Visible only for QNE users (email @qne.com.my, @qne.com.ph, or .qne@gmail.com). */
  isInternal(): boolean {
    const email = (this.settings.user?.['email'] ?? this.settings.user?.['Email'] ?? '') as string;
    if (!email) return false;
    const lower = email.toLowerCase();
    return (
      lower.endsWith('@qne.com.my') ||
      lower.endsWith('@qne.com.ph') ||
      lower.endsWith('.qne@gmail.com')
    );
  }
}
